import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import CopyToClipboard from 'react-copy-to-clipboard'

import Dropdown from 'components/dropdown'

import styles from './copy-to-clipboard.css'

const CopyUrl = ({ snippet, copied, link, onCopy }) => (
  <div styleName={link ? 'copy-to-clipboard-horizontal' : 'copy-to-clipboard-vertical'}>
    <div styleName={link ? 'input-singleline' : 'input-multiline'}>
      {link && <a href={link} styleName="link" target="_blank">{link}</a>}
      {snippet && <pre styleName="snippet">{snippet}</pre>}
    </div>

    <CopyToClipboard text={link || snippet} onCopy={onCopy}>
      <div styleName={link ? 'copy-link' : 'copy-snippet'}>
        {link ? 'Copy Link' : 'Copy Snippet'}
        <div styleName={copied ? 'dropdown-active' : 'dropdown-inactive'}>
          <Dropdown direction="bottom" padding="small">Copied!</Dropdown>
        </div>
      </div>
    </CopyToClipboard>
  </div>
)

CopyUrl.propTypes = {
  copied: PropTypes.bool,
  link: PropTypes.string,
  snippet: PropTypes.any,
  onCopy: PropTypes.func,
}

export default CSSModules(CopyUrl, styles)



/** WEBPACK FOOTER **
 ** ./src/components/copy-to-clipboard/copy-to-clipboard.js
 **/